<template>
  <div class="c-box">
    <a-card style="width: 100%" :bordered="false" :tab-list="tabList" :active-tab-key="roleCode"
      @tabChange="(roleCode) => onTabChange(roleCode, 'roleCode')">
      <p v-if="roleCode === 'school-role'">
        <table-view :columns="schoolTableColumns" type="分社" :data="datasources" :pagination="pagination"
          :loading="loading" ref="schoolModel" @showAddPop="showAddPop" @deleteApply="deleteApply"
          @editInfo="showEditPop" @getLxApplyApplylist="getDatalist" @resetPasswords="resetPasswords"></table-view>
      </p>
      <p v-else-if="roleCode === 'draw-role'">
        <table-view :columns="drawTableColumns" type="学校" :data="datasources" :pagination="pagination"
          :loading="loading" ref="drawModel" @showAddPop="showAddPop" @deleteApply="deleteApply"
          @editInfo="showEditPop" :scroll="{ x: 1400 }" @getLxApplyApplylist="getDatalist" @resetPasswords="resetPasswords"></table-view>
      </p>
      <p v-else>
        <table-view :columns="expertTableColumns" type="专家" :data="datasources" :pagination="pagination"
          :loading="loading" ref="expertModel" @showAddPop="showAddPop" @deleteApply="deleteApply"
          @editInfo="showEditPop" @getLxApplyApplylist="getDatalist" @resetPasswords="resetPasswords"></table-view>
      </p>
    </a-card>
    <a-modal v-model="visible" :title="modalTitle" :afterClose="afterClose">
      <div  v-if="roleCode === 'school-role'">
      <div class="mtb10">
        <span class="color-C73630">*</span>省
      </div>
      <a-select style="width: 100%" @change="provinceChange" :filterOption="filterOption" showSearch v-model="modalData.provincecode">
        <a-select-option v-for="(item, index) in provinceList" :key="index" :value="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
      <p v-if="emptyProvince" :class="emptyProvince ? 'warnColor' : ''">
        省不能为空
      </p>
      <div class="mtb10">
        <span class="color-C73630">*</span>市
      </div>
      <a-select style="width: 100%"  @change="cityChange" :filterOption="filterOption" showSearch v-model="modalData.citycode">
        <a-select-option v-for="(item, index) in cityList" :key="index" :value="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
      <p v-if="emptyCity" :class="emptyCity ? 'warnColor' : ''">
        市不能为空
      </p>
      </div>
      <!-- 学校管理：所属分社 -->
      <div v-if="roleCode === 'draw-role'">
        <div class="mtb10">
          <span class="color-C73630">*</span>分社
        </div>
        <a-select style="width: 100%" @change="branchChange" :filterOption="filterOption" showSearch
          v-model="modalData.branchId">
          <a-select-option v-for="(item, index) in branchList" :key="index" :value="item.id">
            {{ item.realname }}
          </a-select-option>
        </a-select>
        <p v-if="emptyBranch" :class="emptyBranch ? 'warnColor' : ''">
          分社不能为空
        </p>
      </div>
      <!-- 学校管理：学校类型（必填，置于分社下方） -->
      <div v-if="roleCode === 'draw-role'">
        <div class="mtb10"><span class="color-C73630">*</span>学校类型</div>
        <a-select
          style="width: 100%"
          placeholder="请选择学校类型"
          showSearch
          :filterOption="filterOption"
          @change="handleChange"
          v-model="modalData.schoolType"
        >
          <a-select-option
            v-for="(item, index) in schoolTypeList"
            :key="index"
            :value="item.type"
          >
            {{ item.title }}
          </a-select-option>
        </a-select>
        <p v-if="emptySchoolType" :class="emptySchoolType ? 'warnColor' : ''">
          学校类型不能为空
        </p>
      </div>
      <div class="mtb10">
        <span class="color-C73630">*</span>账号
        <span style="color: red">( 注：密码留空则默认Mm_258369 )</span>
      </div>
      <a-input placeholder="请设置登录账号" :disabled="!isAdd" :maxLength="100" v-model="modalData.username" />
      <p v-if="emptyUName" :class="emptyUName ? 'warnColor' : ''">
        账号不能为空
      </p>
      <p v-if="existUName" :class="existUName ? 'warnColor' : ''">
        该账号已存在
      </p>
      <div class="mtb10"><span class="color-C73630">*</span>名称</div>
      <a-input :maxLength="100" placeholder="请设置账号名称" v-model="modalData.realname" />
      <p v-if="emptyLName" :class="emptyLName ? 'warnColor' : ''">
        名称不能为空
      </p>
      <div class="mtb10"><span class="color-C73630">*</span>电话</div>
      <a-input placeholder="请设置账号电话" :maxLength="11" v-model="modalData.phone" @blur="isCorrectphone"
        onkeyup="value=value.replace(/[^\d]/g,'')" />
      <p v-if="emptyPhone" :class="emptyPhone ? 'warnColor' : ''">
        电话不能为空
      </p>
      <p v-if="formatPhone" :class="formatPhone ? 'warnColor' : ''">
        *电话号码格式不正确
      </p>
      <p v-if="existPhone" :class="existPhone ? 'warnColor' : ''">
        电话号码已存在
      </p>
      <div v-if="roleCode === 'school-role' || roleCode === 'draw-role'">
        <div class="mtb10"><span class="color-C73630"></span>联系人姓名</div>
        <a-input placeholder="请输入联系人姓名" :maxLength="11" v-model="modalData.concactUser" />
      </div>
      <!-- 学校新增 / 专家新增和编辑：可设置登录密码，留空则新增用默认密码、编辑不修改密码 -->
      <div v-if="(roleCode === 'draw-role' && isAdd) || roleCode === 'expert-role'">
        <div class="mtb10"><span class="color-C73630"></span>密码</div>
        <a-input-password
          :placeholder="isAdd ? '请输入登录密码（留空则使用默认密码 Mm_258369）' : '请输入新密码（留空则不修改密码）'"
          :maxLength="100"
          v-model="modalData.password"
        />
      </div>
      <template slot="footer">
        <a-button type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>
    <!-- 确认删除 -->
    <a-modal v-model="isDelete" :confirm-loading="confirmLoading" @ok="deleteHandle" @cancel="deleteCancelHandle" text
      cancelText="取消" okText="确认">
      <p>确认删除本条账户数据？</p>
    </a-modal>
  </div>
</template>

<script>
import tableView from "./userTableView";
import {
  lxAddUser,
  lxEditUser,
  lxDeleteUser,
  userLxList,
  userCheck,
  resetPasswords,
} from "../../api/index";
import { getAction } from "@/api/index";

export default {
  name: "",
  components: { tableView },
  props: {},
  data() {
    return {
      tabList: [
        {
          key: "school-role",
          tab: "分社管理",
        },
        {
          key: "draw-role",
          tab: "学校管理",
        },
        {
          key: "expert-role",
          tab: "专家管理",
        },
      ],
      schoolTableColumns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
        },
        {
          title: "账号",
          dataIndex: "username",
          id: "username",
          align: "center",
          scopedSlots: { customRender: "username" },
        },
        {
          title: "名称",
          dataIndex: "realname",
          id: "realname",
          align: "center",
          scopedSlots: { customRender: "realname" },
        },
        {
          title: "联系人姓名",
          dataIndex: "concactUser",
          id: "concactUser",
          align: "center",
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          id: "phone",
          align: "center",
        },
        {
          title: "类型",
          dataIndex: "schoolType_dictText",
          id: "schoolType_dictText",
          align: "center",
          scopedSlots: { customRender: "schoolType" },
        },
        {
          title: "状态",
          dataIndex: "status_dictText",
          id: "status_dictText",
          align: "center",
        },
        // {
        //   title: "类型",
        //   dataIndex: "schoolType_dictText",
        //   id: "schoolType_dictText",
        //   align: "center",
        // },
        {
          title: "操作",
          id: "action",
          align: "center",
          width: 354,
          scopedSlots: { customRender: "action" },
        },
      ],
      schoolTableColumns1: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          width: 80,
        },
        {
          title: "省份",
          dataIndex: "provincecode_dictText",
          id: "provincecode_dictText",
          align: "center",
          width: 100,
        },
        {
          title: "账号",
          dataIndex: "username",
          id: "username",
          align: "center",
          scopedSlots: { customRender: "username" },
          width: 110,
        },
        {
          title: "名称",
          dataIndex: "realname",
          id: "realname",
          align: "center",
          scopedSlots: { customRender: "realname" },
        },
        {
          title: "联系人姓名",
          dataIndex: "concactUser",
          id: "concactUser",
          align: "center",
          width: 114,
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          id: "phone",
          align: "center",
        },
        {
          title: "状态",
          dataIndex: "status_dictText",
          id: "status_dictText",
          align: "center",
          width: 80,
          scopedSlots: { customRender: "status" },
        },
        // {
        //   title: "类型",
        //   dataIndex: "schoolType_dictText",
        //   id: "schoolType_dictText",
        //   align: "center",
        //   width: 100,
        // },
        {
          title: "操作",
          id: "action",
          align: "center",
          width: 324,
          scopedSlots: { customRender: "action" },
        },
      ],
      // 学校管理列表（draw-role）
      drawTableColumns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
        },
        {
          title: "分社",
          dataIndex: "branchName",
          id: "branchName",
          align: "center",
          scopedSlots: { customRender: "branch" },
        },
        {
          title: "类型",
          dataIndex: "schoolType_dictText",
          id: "schoolType_dictText",
          align: "center",
          scopedSlots: { customRender: "schoolType" },
        },
        {
          title: "账号",
          dataIndex: "username",
          id: "username",
          align: "center",
          scopedSlots: { customRender: "username" },
        },
        {
          title: "名称",
          dataIndex: "realname",
          id: "realname",
          align: "center",
          scopedSlots: { customRender: "realname" },
        },
        {
          title: "联系人姓名",
          dataIndex: "concactUser",
          id: "concactUser",
          align: "center",
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          id: "phone",
          align: "center",
        },
        {
          title: "状态",
          dataIndex: "status_dictText",
          id: "status_dictText",
          align: "center",
        },
        {
          title: "操作",
          id: "action",
          align: "center",
          width: 354,
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      // 学校管理列表（省级项目展示，列宽固定）
      drawTableColumns1: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          width: 80,
        },
        {
          title: "分社",
          dataIndex: "branchName",
          id: "branchName",
          align: "center",
          // width: 100,
          scopedSlots: { customRender: "branch" },
        },
        {
          title: "类型",
          dataIndex: "schoolType_dictText",
          id: "schoolType_dictText",
          align: "center",
          scopedSlots: { customRender: "schoolType" },
        },
        {
          title: "账号",
          dataIndex: "username",
          id: "username",
          align: "center",
          scopedSlots: { customRender: "username" },
          // width: 80,
        },
        {
          title: "名称",
          dataIndex: "realname",
          id: "realname",
          align: "center",
          scopedSlots: { customRender: "realname" },
        },
        {
          title: "联系人姓名",
          dataIndex: "concactUser",
          id: "concactUser",
          align: "center",
          width: 114,
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          id: "phone",
          align: "center",
        },
        {
          title: "状态",
          dataIndex: "status_dictText",
          id: "status_dictText",
          align: "center",
          width: 80,
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          id: "action",
          align: "center",
          width: 324,
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      expertTableColumns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
        },
        {
          title: "账号",
          dataIndex: "username",
          id: "username",
          align: "center",
          scopedSlots: { customRender: "username" },
        },
        {
          title: "名称",
          dataIndex: "realname",
          id: "realname",
          align: "center",
          scopedSlots: { customRender: "realname" },
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          id: "phone",
          align: "center",
        },
        {
          title: "操作",
          id: "action",
          align: "center",
          width: 354,
          scopedSlots: { customRender: "action" },
        },
      ],
      datasources: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 20, //每页中显示10条数据
      },
      modalData: {
        username: "",
        realname: "",
        phone: "",
        schoolType: "",
        concactUser: '',
        provincecode:'',
        citycode:'',
        branchId:'',
        branchName:'',
        password:'',
      },
      schoolTypeList: [
        { type: "1", title: "中职学校" },
        { type: "2", title: "高职学校" },
      ],
      visible: false,
      isAdd: true, // 新增 true 修改 false
      modalTitle: "",
      isDelete: false,
      confirmLoading: false,
      userId: "",
      roleCode: "school-role",
      loading: true,
      emptyUName: false, //账号是否为空
      existUName: false, //账号是否存在
      emptyLName: false, //名称是否为空
      emptyPhone: false, //电话是否为空
      formatPhone: false, //电话格式是否正确
      existPhone: false, //电话是否存在
      emptyProvince:false,
      emptyCity:false,
      emptyBranch:false, //分社是否为空
      emptySchoolType:false, //学校类型是否为空
      provinceList: [],
      cityList: [],
      branchList: [], // 分社下拉（school-role 账号列表）
    };
  },
  computed: {},
  watch: {},
  created() {
    if (this.$store.state.region == '5') {
      this.schoolTableColumns = this.schoolTableColumns1;
      this.drawTableColumns = this.drawTableColumns1;
    }
  },
  mounted() {
    this.getDatalist({
      current: 1,
      pageSize: 20,
    });
    if(this.roleCode=='school-role'){
      this.getProvince();
    }
    this.getBranchList();
    
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 切换学校/专家
    onTabChange(key, type) {
      this[type] = key;
      (this.pagination = {
        total: 0,
        current: 1,
        pageSize: 20, //每页中显示10条数据
      }),
        this.getDatalist(this.pagination);
    },
    // 新增 - 显示
    showAddPop(type) {
      this.modalTitle = "新增" + type;
      this.modalData.schoolType = "";
      this.modalData.branchId = "";
      this.modalData.branchName = "";
      this.modalData.password = "";
      this.emptyBranch = false;
      this.emptySchoolType = false;
      this.isAdd = true;
      this.visible = true;
    },
    // 修改 - 显示 - 数据回显
    showEditPop(row) {
      this.modalData.username = row.username;
      this.modalData.realname = row.realname;
      this.modalData.phone = row.phone;
      this.modalData.schoolType = row.schoolType;
      this.modalData.concactUser = row.concactUser;
      this.modalData.password = "";
      this.modalData.id = row.id;
       this.getProvince();
      if(this.roleCode=='school-role'){
         this.modalData.provincecode=row.provincecode;
         this.provinceChange(row.provincecode);
         this.modalData.citycode=row.citycode;
      }
      if(this.roleCode=='draw-role'){
         this.modalData.branchId=row.branchId || row.parentId || '';
         this.modalData.branchName=row.branchName || '';
         this.emptyBranch=false;
         this.emptySchoolType=false;
      }
      this.isAdd = false;
      this.visible = true;
    },

    // 新增或修改调用接口
    handleOk() {
      this.emptyUName = false;
      this.emptyLName = false;
      this.emptyPhone = false;
      this.formatPhone = false;
      this.existUName = false;
      this.existPhone = false;
      this.emptyProvince = false;
      this.emptyCity = false;
      this.emptyBranch = false;
      this.emptySchoolType = false;
      this.modalData.roleCode = this.roleCode;
      this.modalData.schoolType =
        this.roleCode === "expert-role" ? undefined : this.modalData.schoolType;
      let timestamp = new Date().getTime();
      let reg = /^1[3-9][0-9]{9}$/g;
      // debugger
      if(this.roleCode=='school-role'){
        if(this.modalData.provincecode==''){
           this.emptyProvince = true;
        }else{
           this.emptyProvince = false;
        }
        this.emptyCity = false;
      }
      if(this.roleCode=='draw-role'){
        if(!this.modalData.branchId){
           this.emptyBranch = true;
        }else{
           this.emptyBranch = false;
           // 顺带把分社名称一起提交，方便后端冗余存储 / 列表回显
           let branch = this.branchList.find(
             (item) => item.id === this.modalData.branchId
           );
           this.modalData.branchName = branch ? branch.realname : "";
        }
        // 学校类型必填
        if(!this.modalData.schoolType){
           this.emptySchoolType = true;
        }else{
           this.emptySchoolType = false;
        }
      }
      if (this.modalData.username === "") {
        this.emptyUName = true;
      } else {
        this.emptyUName = false;
      }
      if (this.modalData.realname === "") {
        this.emptyLName = true;
      } else {
        this.emptyLName = false;
      }
      if (this.modalData.phone === "") {
        this.emptyPhone = true;
      } else {
        this.emptyPhone = false;
        let a = reg.test(this.modalData.phone);
        // debugger
        if (a) {
          this.formatPhone = false;
          // console.log(this.formatPhone)
        } else {
          this.formatPhone = true;
          // console.log('1111111111')
          // console.log(this.existPhone)
        }
      }
      let roleValid = true;
      if (this.roleCode == 'school-role') {
        roleValid = this.emptyProvince === false;
      } else if (this.roleCode == 'draw-role') {
        roleValid = this.emptyBranch === false && this.emptySchoolType === false;
      }
      // console.log(this.emptyUName===false&&this.emptyLName===false&&this.emptyPhone===false&&this.formatPhone===false)
      if (
        this.emptyUName === false &&
        this.emptyLName === false &&
        this.emptyPhone === false &&
        this.formatPhone === false &&
        roleValid
      ) {
        if (this.isAdd) {
          let obj = {
            _t: timestamp,
            tableName: "sys_user",
            fieldName: "username",
            fieldVal: this.modalData.username,
          };
          userCheck(obj).then((res) => {
            console.log(res)
            if (res.code == 200) {
              this.existUName = false;
              let obj = {
                _t: timestamp,
                tableName: "sys_user",
                fieldName: "phone",
                fieldVal: this.modalData.phone,
              };
              userCheck(obj).then((res) => {
                // console.log(res)
                if (res.code == 200) {
                  this.existPhone = false;
                  lxAddUser(this.modalData).then((res) => {
                    if (res.code === 200) {
                      this.$message.success(res.message);
                    } else {
                      this.$message.error(res.message);
                    }
                    this.getDatalist(this.pagination);
                    this.visible = false;
                    this.$forceUpdate();
                  });
                } else {
                  this.existPhone = true;
                }
              });
            } else {
              this.existUName = true;
              let obj = {
                _t: timestamp,
                tableName: "sys_user",
                fieldName: "phone",
                fieldVal: this.modalData.phone,
              };
              userCheck(obj).then((res) => {
                // console.log(res)
                if (res.code == 200) {
                  this.existPhone = false;
                } else {
                  this.existPhone = true;
                }
              });
            }
          });
        } else {
          let obj = {
            _t: timestamp,
            tableName: "sys_user",
            fieldName: "phone",
            fieldVal: this.modalData.phone,
            dataId: this.modalData.id,
          };
          userCheck(obj).then((res) => {
            //  console.log(res)
            if (res.code == 200) {
              this.existPhone = false;
              lxEditUser(this.modalData).then((res) => {
                if (res.code === 200) {
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
                this.getDatalist(this.pagination);
                this.visible = false;
                this.$forceUpdate();
              });
            } else {
              this.existPhone = true;
            }
          });
        }
      }
    },

    // 重置密码
    resetPasswords(row) {
      const _this = this;
      this.$confirm({
        title: `你确定初始 ${row.username} 的密码为'Mm_258369'吗`,
        cancelText: "取消",
        okText: "确定",
        onOk() {
          const data = {
            id: row.id,
          };
          resetPasswords(data).then((res) => {
            if (res.code == 200) {
              _this.$message.success(res.message);
            } else {
              _this.$message.error(res.message);
            }
          });
        },
        onCancel() { },
      });
    },
    // 删除
    deleteApply(id) {
      this.userId = id;
      this.isDelete = true;
    },
    deleteHandle() {
      let obj = { id: this.userId };
      lxDeleteUser(obj).then((res) => {
        if (res.code === 200) {
          this.isDelete = false;
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.getDatalist(this.pagination);
        this.$forceUpdate();
      });
    },
    deleteCancelHandle() {
      this.visible = false;
    },

    // 列表
    getDatalist(pagination) {
      this.loading = true;
      let data = {
        roleCode: this.roleCode,
        pageNo: pagination.current,
        pageSize: pagination.pageSize,
      };
      userLxList(data).then((res) => {
        if (res.code == 200) {
          this.datasources = res.result.records;
          this.pagination.total = res.result.total;
          this.datasources.forEach((item, index) => {
            item.sequenceNumber = index + 1;
          });
        }
        this.loading = false;
      });
    },

    // 添加页的关闭
    afterClose() {
      this.modalData = {
        username: "",
        realname: "",
        phone: "",
        schoolType: "",
        concactUser: "",
        provincecode: "",
        citycode: "",
        branchId: "",
        branchName: "",
        password: "",
      };
      this.emptyUName = false;
      this.emptyLName = false;
      this.emptyPhone = false;
      this.formatPhone = false;
      this.existUName = false;
      this.existPhone = false;
      this.emptyProvince = false;
      this.emptyCity = false;
      this.emptyBranch = false;
      this.emptySchoolType = false;
    },
    isCorrectphone() {
      var telStr = /^[1]([3-9])[0-9]{9}$/;
      if (this.modalData.phone === "") {
        this.emptyPhone = true;
        return false
      } else {
        this.emptyPhone = false;
      }
      if (!telStr.test(this.modalData.phone)) {
        this.formatPhone = true;
        return false
      } else {
        this.formatPhone = false;
      }
    },
    // 添加页的类型切换
    handleChange(value) {
      this.modalData.schoolType = value;
    },
    // 获取省
    getProvince() {
      getAction("/pcity/queryByPid", { pid: 0 }).then((res) => {
        if (res.code == 200) {
          this.provinceList = res.result;
        }
      });
    },
    // 获取分社列表（分社管理 school-role 的账号，作为学校所属分社下拉）
    getBranchList() {
      userLxList({ roleCode: "school-role", pageNo: 1, pageSize: 999 }).then(
        (res) => {
          if (res.code == 200) {
            this.branchList = (res.result && res.result.records) || [];
          }
        }
      );
    },
    branchChange(id) {
      this.emptyBranch = false;
      let branch = this.branchList.find((item) => item.id === id);
      this.modalData.branchName = branch ? branch.realname : "";
      this.$forceUpdate();
    },
    cityChange(id){
        this.emptyCity=false;
        this.$forceUpdate();
    },
    // 选择省份获取市
    provinceChange(id) {
      this.emptyProvince=false;
      getAction("/pcity/queryByPid", { pid: id }).then((res) => {
        if (res.code == 200) {
          this.cityList = res.result;
          this.modalData.city='';
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.c-box {
  height: 100%;
  overflow: auto;
}

.mtb10 {
  margin: 10px 0;
}

.color-C73630 {
  color: #c73630;
  padding-right: 10px;
}

.warnColor {
  color: red;
  font-size: 14px;
}
</style>
